export const ESTIMATE_SHORTCUTS = [
	{ code: 'KeyB', target: 'bunker-price', description: 'First active bunker price' },
	{ code: 'KeyC', target: 'cargo-commodity', description: 'Cargo commodity' },
	{ code: 'KeyP', target: 'first-port', description: 'First port in the port rotation (its Port DA in grid view)' },
	{ code: 'KeyT', target: 'tce-target', description: 'TCE target' },
	{ code: 'KeyV', target: 'vessel', description: 'Vessel' },
];

export const ESTIMATE_SHORTCUT_TARGETS = Object.fromEntries(
	ESTIMATE_SHORTCUTS.map(({ code, target }) => [code, target]),
);
